import { Pill } from '../../ui/Pill';
import { ProjectExplorerPreview } from '../../ui/ImagePlaceholder';
import { WorkspacePlaceholder } from '../../ui/WorkspacePlaceholder';
import './styles.css';

export function FeatureSplits() {
  return (
    <>
      <section className="section sectionAlt">
        <div className="container split">
          <div className="splitMedia">
            <ProjectExplorerPreview title="Project Explorer" />
          </div>

          <div className="splitCopy">
            <Pill variant="blue">Discover</Pill>
            <h2>
              Find the perfect <span className="accent">project</span> across Europe
            </h2>
            <p className="muted">
              Our Project Explorer lets you browse initiatives by discipline, university, or required skills. Join an
              existing idea or pitch your own to attract international talent.
            </p>
            <ul className="list">
              <li>Skill-based matching algorithm</li>
              <li>Cross-disciplinary tagging</li>
              <li>Real-time capacity indicators</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container split reverse">
          <div className="splitCopy">
            <Pill variant="green">Workspace</Pill>
            <h2>
              Built-in <span className="accent">Team Workspace</span>
            </h2>
            <p className="muted">
              Stop juggling five different tools. Studenio provides a unified workspace for your international team to
              chat, share files, and track progress.
            </p>
            <ul className="list">
              <li>Integrated task boards (Kanban)</li>
              <li>Document collaboration</li>
              <li>Teacher oversight dashboard</li>
            </ul>
          </div>

          <div className="splitMedia">
            <WorkspacePlaceholder wide />
          </div>
        </div>
      </section>
    </>
  );
}

